import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /**
   * Animate between the collapsed and expanded content heights. Respects reduced-motion preferences.
   *
   * @type {Boolean|String}
   * @default false
   */
  animated: booleanAttribute(),
  /**
   * Initial expanded state.
   *
   * @type {Boolean|String}
   * @default false
   */
  expanded: booleanAttribute(),
  /**
   * Activator label shown when expanded. Falls back to the title attribute when not set.
   *
   * @type {String}
   * @default undefined
   */
  expandedTitle: {
    type: String,
    default: undefined,
  },
  /**
   * Position of the activator relative to the collapsed or expanded content.
   *
   * @type {String}
   * @default "start"
   */
  activatorPosition: {
    type: String,
    default: "start",
    validator: (value) => ["start", "end"].includes(value),
  },
  /**
   * Colour for the activator label and caret. Overrides --sp-comp-expandable-area-activator-color.
   *
   * @type {String}
   * @default undefined
   */
  color: {
    type: String,
    default: undefined,
  },
});
